var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-width"},[(this.icons)?_c('font-awesome-icon',{attrs:{"icon":this.icons}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }